import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  listRecvocTenants,
  issueRecvocTenant,
  revokeRecvocTenant,
  updateRecvocTenant,
} from "../services/recvocTenantService";
import type {
  IssueRecvocTenantRequest,
  UpdateRecvocTenantRequest,
} from "../types/recvocTenant.types";

export const useRecvocTenants = (companyGuid: string | null) =>
  useQuery({
    queryKey: ["recvocTenants", companyGuid],
    queryFn: () => listRecvocTenants(companyGuid!),
    enabled: !!companyGuid,
    staleTime: 5_000,
  });

export const useIssueRecvocTenant = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req: IssueRecvocTenantRequest) => issueRecvocTenant(req),
    onSuccess: (_, vars) => {
      toast.success("RecVoc 키가 발급되었습니다.");
      qc.invalidateQueries({ queryKey: ["recvocTenants", vars.companyGuid] });
    },
    onError: (err: Error) => toast.error(`발급 실패: ${err.message}`),
  });
};

export const useRevokeRecvocTenant = (companyGuid: string | null) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (idx: number) => revokeRecvocTenant(idx),
    onSuccess: () => {
      toast.success("RecVoc 키가 폐기되었습니다.");
      qc.invalidateQueries({ queryKey: ["recvocTenants", companyGuid] });
    },
    onError: (err: Error) => toast.error(`폐기 실패: ${err.message}`),
  });
};

export const useUpdateRecvocTenant = (companyGuid: string | null) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: { idx: number; req: UpdateRecvocTenantRequest }) =>
      updateRecvocTenant(args.idx, args.req),
    onSuccess: () => {
      toast.success("수정되었습니다.");
      qc.invalidateQueries({ queryKey: ["recvocTenants", companyGuid] });
    },
    onError: (err: Error) => toast.error(`수정 실패: ${err.message}`),
  });
};
